import { render, staticRenderFns } from "./FinancialResponsible.vue?vue&type=template&id=f70463b2"
import script from "./FinancialResponsible.vue?vue&type=script&lang=js"
export * from "./FinancialResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports